(function() {
const BuildYourStarterKit = function() {
	function BuildYourStarterKit() {
			this.selector = {
					section_element: document.querySelector('.build-your-start-kit-section'),
					step1_products: document.querySelectorAll('.steps-diffuser-products.step-1'),
					step2_products: document.querySelectorAll('.steps-diffuser-products.step-2'),
					next_steps: document.querySelectorAll('.next-steps-button'),
					steps: document.querySelectorAll('.build-your-start-kit-section .build-your-start-kit-container .steps'),
					prev_steps: document.querySelectorAll('.previous-steps-button'),
					show_info: document.querySelectorAll('.show-product-info'),
					step1_progressbar: document.getElementById('step1-progressbar'),
					step2_progressbar: document.getElementById('step2-progressbar'),
					step3_progressbar: document.getElementById('step3-progressbar'),
					subscription_label: document.querySelectorAll('.build-your-start-kit-section .build-your-start-kit-container .steps[data-this-step="3"] > .final-steps-container .final-details .selling-plan label'),
					subscription_input: document.querySelectorAll('.build-your-start-kit-section .build-your-start-kit-container .steps[data-this-step="3"] > .final-steps-container .final-details .selling-plan .selling-plan-id'),
					arrow_steps: document.querySelectorAll('.build-your-start-kit-section .build-your-start-kit-container .steps .right-picker .right-content .products-picker label .details .price .arrow'),
					final_order_purchase: document.getElementById('final-order-purchase'),
					step2_replaceable_image: document.getElementById('step2_replaceable_image'),
					variant_selling_plan_selected: document.getElementById('variant_selling_plan_selected'),
					secondproductselectedimagerender: document.getElementById('second-product-selected-image-render'),
					plan_selector: document.querySelectorAll('.details-selector-input'),
					plan_price: document.querySelector('.plan-price')
			}
			this.discount = {
					onetime: this.selector.section_element ? this.selector.section_element.dataset.discountOnetime : 'FREESCENT',
					subscription: this.selector.section_element ? this.selector.section_element.dataset.discountSubscription : 'FREESCENT_SUB',
					delivery_frequency: this.selector.section_element ? this.selector.section_element.dataset.deliveryFrequency : 'null',
					redirect_page: this.selector.section_element && this.selector.section_element.dataset.redirectPage ? this.selector.section_element.dataset.redirectPage : '/pages/cro-test-a',
					step_3_mode: this.selector.section_element ? (this.selector.section_element.dataset.step3Mode || this.selector.section_element.getAttribute('data-step-3-mode') || 'redirect') : 'redirect',
					diffuser_extra_property: this.selector.section_element ? this.selector.section_element.dataset.diffuserExtraProperty : '',
					diffuser_discount_percent: this.selector.section_element ? parseInt(this.selector.section_element.dataset.diffuserDiscountPercent) || 0 : 0
			}
			this.state = {
					first_product: null,
					second_product: null,
					selling_plan: null,
					discounted: {
							first_product: 0,
							second_product: 0
					},
					regular: {
							first_product: 0,
							second_product: 0
					},
					filteredVariantSellingPlan: [],
					discounted_first_product: 0
			}
			this.final = {
					first_product: {
							image: document.getElementById('first-product-selected-image'),
							title: document.getElementById('first-product-selected-title'),
							discount_price: document.getElementById('first-product-selected-discount-price'),
							regular_price: document.getElementById('first-product-selected-regular-price'),
							selling_plan: document.getElementById('first-product-selected-selling-plan'),
							discount_badge: document.getElementById('first-product-discount-badge'),
						discount_badge_alt: document.getElementById('first-product-discount-badge-alt')
					},
					second_product: {
							image: document.getElementById('second-product-selected-image'),
							title: document.getElementById('second-product-selected-title'),
							discount_price: document.getElementById('second-product-selected-discount-price'),
							regular_price: document.getElementById('second-product-selected-regular-price'),
							regular_price_origin: document.getElementById('second-product-selected-regular-price-origin'),
							selling_plan: document.getElementById('second-product-selected-selling-plan')
					},
					selling_plan: {
							subscription: document.getElementById('final-selected-discounted-price'),
							onetimepurchase: document.getElementById('final-one-time-purchase-price'),
							finalorderdiscount: document.getElementById('final-order-discount'),
							finalorderregular: document.getElementById('final-order-regular'),
							finalplanname: document.getElementById('final-selected-selling-plan-name')
					} 
			}
			this.load();
	}
	BuildYourStarterKit.prototype.load = function() {
			var _ = this;
			if(_.selector.step1_products.length > 0) {
					_.selector.step1_products.forEach(el => {
							el.addEventListener('click', event => {
									_.selector.step1_products.forEach(label => {
											label.classList.remove('active');
									})
									event.target.closest('label').classList.add('active');
									if(event.target.closest('label').classList.contains('active')) {
											_.final.first_product.image.src = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage;
											_.final.first_product.image.dataset.src = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage;
											_.final.first_product.title.textContent = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantTitle;
											_.final.first_product.regular_price.textContent = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantPrice;
											_.state.first_product = event.target.closest('label').querySelector('input[type="radio"]').value;
											const current_currency = el.querySelector('input[type="radio"]').dataset.currentCurrency;
											const regular_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;
											_.state.regular.first_product = regular_price;

											// Apply visual diffuser discount if configured
											if (_.discount.diffuser_discount_percent > 0) {
												const discountedDiffuserPrice = regular_price * (1 - _.discount.diffuser_discount_percent / 100);
												_.state.discounted_first_product = discountedDiffuserPrice;
												// Show badge
												if (_.final.first_product.discount_badge) {
													_.final.first_product.discount_badge.textContent = _.discount.diffuser_discount_percent + '% OFF';
													_.final.first_product.discount_badge.style.display = 'inline-block';
												}
												if (_.final.first_product.discount_badge_alt) {
													_.final.first_product.discount_badge_alt.textContent = _.discount.diffuser_discount_percent + '% OFF';
													_.final.first_product.discount_badge_alt.style.display = 'inline-block';
												}
												// Show original price crossed out
												if (_.final.first_product.discount_price) {
													_.final.first_product.discount_price.textContent = `${current_currency}${regular_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
													_.final.first_product.discount_price.style.display = 'inline';
													_.final.first_product.discount_price.classList.add('underline');
												}
												// Show discounted price
												_.final.first_product.regular_price.textContent = `${current_currency}${discountedDiffuserPrice.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
												_.final.first_product.regular_price.classList.remove('underline');
											} else {
												_.state.discounted_first_product = regular_price;
												// Hide badge
												if (_.final.first_product.discount_badge) {
													_.final.first_product.discount_badge.style.display = 'none';
												}
												if (_.final.first_product.discount_badge_alt) {
													_.final.first_product.discount_badge_alt.style.display = 'none';
												}
												// Hide crossed out price
												if (_.final.first_product.discount_price) {
													_.final.first_product.discount_price.style.display = 'none';
												}
											}

											// Update prices: discount shows total, regular shows just diffuser (second product is free)
						const finalOrderTotal = parseInt(_.state.regular.first_product) + parseInt(_.state.regular.second_product);
						if (_.final.selling_plan.finalorderdiscount && _.state.regular.second_product > 0) {
							_.final.selling_plan.finalorderdiscount.textContent = `${current_currency}${finalOrderTotal.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
						}
						// Use discounted diffuser price if available, otherwise regular price
						const final_regular_price = _.discount.diffuser_discount_percent > 0 ? parseInt(_.state.discounted_first_product) : parseInt(_.state.regular.first_product);
											_.final.selling_plan.finalorderregular.textContent = `${current_currency}${final_regular_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
											_.selector.subscription_input.forEach(detail => {
													if(detail.checked) {
															if(detail.value !== 'one-time-purchase') {
																	const one_time_purchase_discount = parseInt(detail.dataset.oneTimePurchaseDiscount) * 0.01;
																	const refined_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;                                
																	const discounted_amount = refined_price * one_time_purchase_discount;
																	const final_discounted_amount = refined_price - discounted_amount;
																	_.final.first_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
																	_.state.discounted.first_product = final_discounted_amount;
																	const total_final_discount = _.state.discounted.first_product + _.state.discounted.second_product;
																	// _.final.selling_plan.finalorderdiscount.textContent = `${current_currency}${ total_final_discount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
																	_.final.selling_plan.finalorderregular.classList.add('underline');
																	_.final.first_product.discount_price.classList.remove('underline');
																	_.final.first_product.regular_price.classList.add('underline');
															}  else {
																	const one_time_purchase_discount = parseInt(detail.dataset.oneTimePurchaseDiscount) * 0.01;
																	const refined_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;                                
																	const discounted_amount = refined_price * one_time_purchase_discount;
																	const final_discounted_amount = refined_price - discounted_amount;
																	_.final.first_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
																	_.state.discounted.first_product = final_discounted_amount;
																	const total_final_discount = _.state.discounted.first_product + _.state.discounted.second_product;
																	// _.final.selling_plan.finalorderdiscount.textContent = `${current_currency}${ total_final_discount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
																	_.final.selling_plan.finalorderregular.classList.remove('underline');                                    
																	_.final.first_product.discount_price.classList.add('underline');
																	_.final.first_product.regular_price.classList.remove('underline');
															}                         
													}
											})
									}
							})
							if(el.closest('label').classList.contains('active')) {
									_.state.first_product = el.querySelector('input[type="radio"]').value;
									_.final.first_product.image.src = el.querySelector('input[type="radio"]').dataset.variantImage;
									_.final.first_product.image.dataset.src = el.querySelector('input[type="radio"]').dataset.variantImage;
									_.final.first_product.title.textContent = el.querySelector('input[type="radio"]').dataset.variantTitle;
									_.final.first_product.regular_price.textContent = el.querySelector('input[type="radio"]').dataset.variantPrice;
									var current_currency = el.querySelector('input[type="radio"]').dataset.currentCurrency;
									const regular_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;
									_.state.regular.first_product = regular_price;

									// Apply visual diffuser discount if configured (initialization)
									if (_.discount.diffuser_discount_percent > 0) {
										const discountedDiffuserPrice = regular_price * (1 - _.discount.diffuser_discount_percent / 100);
										_.state.discounted_first_product = discountedDiffuserPrice;
										// Show badge
										if (_.final.first_product.discount_badge) {
											_.final.first_product.discount_badge.textContent = _.discount.diffuser_discount_percent + '% OFF';
											_.final.first_product.discount_badge.style.display = 'inline-block';
										}
										if (_.final.first_product.discount_badge_alt) {
											_.final.first_product.discount_badge_alt.textContent = _.discount.diffuser_discount_percent + '% OFF';
											_.final.first_product.discount_badge_alt.style.display = 'inline-block';
										}
										// Show original price crossed out
										if (_.final.first_product.discount_price) {
											_.final.first_product.discount_price.textContent = `${current_currency}${regular_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
											_.final.first_product.discount_price.style.display = 'inline';
											_.final.first_product.discount_price.classList.add('underline');
										}
										// Show discounted price
										_.final.first_product.regular_price.textContent = `${current_currency}${discountedDiffuserPrice.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
										_.final.first_product.regular_price.classList.remove('underline');
									} else {
										_.state.discounted_first_product = regular_price;
									}

									// Use discounted diffuser price if available, otherwise regular price
									const final_regular_price = _.discount.diffuser_discount_percent > 0 ? parseInt(_.state.discounted_first_product) : parseInt(_.state.regular.first_product);
									_.final.selling_plan.finalorderregular.textContent = `${current_currency}${final_regular_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
									_.selector.subscription_input.forEach(detail => {
											if(detail.checked) {
													if(detail.value !== 'one-time-purchase') {
															const one_time_purchase_discount = parseInt(detail.dataset.oneTimePurchaseDiscount) * 0.01;
															const refined_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;                                
															const discounted_amount = refined_price * one_time_purchase_discount;
															const final_discounted_amount = refined_price - discounted_amount;
															_.final.first_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
															_.state.discounted.first_product = final_discounted_amount;
															const total_final_discount =  _.state.discounted.first_product + _.state.discounted.second_product;
															_.final.selling_plan.finalorderregular.classList.add('underline');
															_.final.first_product.regular_price.classList.add('underline');
															_.final.first_product.discount_price.classList.remove('underline');
													}  else {
															const one_time_purchase_discount = parseInt(detail.dataset.oneTimePurchaseDiscount) * 0.01;
															const refined_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;                                
															const discounted_amount = refined_price * one_time_purchase_discount;
															const final_discounted_amount = refined_price - discounted_amount;
															_.final.first_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
															_.state.discounted.first_product = final_discounted_amount;
															const total_final_discount =  _.state.discounted.first_product + _.state.discounted.second_product;
															_.final.selling_plan.finalorderregular.classList.add('underline');
															_.final.first_product.regular_price.classList.remove('underline');
															_.final.first_product.discount_price.classList.add('underline');
													}                         
											}
									})
							}
					})
			}
			if(_.selector.step2_products.length > 0) {
					_.selector.step2_products.forEach(el => {
							el.addEventListener('click', event => {
									_.selector.step2_products.forEach(label => {
											label.classList.remove('active');
									})
									_.state.filteredVariantSellingPlan = [];
									_.state.filteredVariantSellingPlan = window.second_products_selling_plan.filter(plan => plan.variantId === event.target.closest('label').querySelector('input[type="radio"]').value);
									if(_.state.filteredVariantSellingPlan.length > 0) {
											if(_.selector.variant_selling_plan_selected) {
													_.selector.variant_selling_plan_selected.innerHTML = "";
													_.state.filteredVariantSellingPlan.forEach((option, index) => {
															var selling_plan_option = document.createElement("option");
															selling_plan_option.value = option.sellingPlanId;
															selling_plan_option.text = option.sellingPlanName;
															selling_plan_option.dataset.sellingPlanPriceType = option.sellingPlanPriceType;
															selling_plan_option.dataset.sellingPlanPriceValue = option.sellingPlanPriceValue;
															selling_plan_option.dataset.variantId = option.variantId;
															selling_plan_option.dataset.variantPrice = option.variantPrice;
															selling_plan_option.dataset.currentCurrency = option.currentCurrency;
															selling_plan_option.dataset.sellingPlanId = option.sellingPlanId;
															index == 0 && (selling_plan_option.selected = true);
															_.selector.variant_selling_plan_selected.append(selling_plan_option);
													})                                
											}                            
									}
									event.target.closest('label').classList.add('active');
									if(event.target.closest('label').classList.contains('active')) {
											_.selector.secondproductselectedimagerender && (_.selector.secondproductselectedimagerender.src = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage);
											_.selector.secondproductselectedimagerender && (_.selector.secondproductselectedimagerender.dataset.src = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage);
											_.selector.secondproductselectedimagerender && (_.selector.secondproductselectedimagerender.srcset = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage);
											_.final.second_product.image.src = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage;
											_.final.second_product.image.dataset.src = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage;
											_.final.second_product.title.textContent = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantTitle;
											_.final.second_product.regular_price.textContent = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantPrice;

											// Calculate discounted price from selling plan for regular_price_origin
											const current_currency = el.querySelector('input[type="radio"]').dataset.currentCurrency;
											const regular_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;

											// Find the 6-week selling plan to get the discount
											const variantId = event.target.closest('label').querySelector('input[type="radio"]').value;
											const variantSellingPlans = window.second_products_selling_plan.filter(plan => plan.variantId === variantId);
											const sixWeekPlan = variantSellingPlans.find(plan =>
												plan.sellingPlanName &&
												plan.sellingPlanName.toLowerCase().includes('6') &&
												plan.sellingPlanName.toLowerCase().includes('week')
											);

											if (sixWeekPlan && sixWeekPlan.sellingPlanPriceValue) {
												const discount_percentage = parseInt(sixWeekPlan.sellingPlanPriceValue) * 0.01;
												const discounted_price = regular_price - (regular_price * discount_percentage);
												_.final.second_product.regular_price_origin.textContent = `${current_currency}${discounted_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
											} else {
												_.final.second_product.regular_price_origin.textContent = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantPrice;
											}

											_.final.second_product.regular_price.classList.add('underline');
											// _.final.second_product.discount_price.classList.remove('underline');
											_.state.second_product = variantId;
											// Update final-order-discount to show total before free second product discount
			const finalOrderDiscount = parseInt(_.state.regular.first_product) + parseInt(regular_price);
											_.final.selling_plan.finalorderdiscount.textContent = `${current_currency}${finalOrderDiscount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
											_.state.regular.second_product = regular_price;
											// Update final-order-regular to show just diffuser price (second product is free)
											// Use discounted diffuser price if available, otherwise regular price
			const final_regular_price = _.discount.diffuser_discount_percent > 0 ? parseInt(_.state.discounted_first_product) : parseInt(_.state.regular.first_product);
											_.final.selling_plan.finalorderregular.textContent = `${current_currency}${final_regular_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
											// _.final.selling_plan.finalplanname.textContent =`${_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].text}`;
											_.selector.subscription_input.forEach(detail => {
													if(detail.checked) {
															if(detail.value !== 'one-time-purchase') {                                    
																	const one_time_purchase_discount = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanPriceValue) * 0.01;
																	const refined_price = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.variantPrice) / 100;                                
																	const discounted_amount = refined_price * one_time_purchase_discount;
																	const final_discounted_amount = refined_price - discounted_amount;
																	_.final.second_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
																	_.state.discounted.second_product = final_discounted_amount;
																	_.final.selling_plan.subscription.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
																	const total_final_discount =  _.state.discounted.first_product + _.state.discounted.second_product;
																	_.final.selling_plan.finalorderregular.classList.add('underline');
																	_.final.second_product.regular_price.classList.add('underline');
																	// _.final.second_product.discount_price.classList.remove('underline');
																	detail.value = _.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanId;
																	_.state.selling_plan = _.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanId;
															}  else {
																	const one_time_purchase_discount = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanPriceValue) * 0.01;
																	const refined_price = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.variantPrice) / 100;                                
																	const discounted_amount = refined_price * one_time_purchase_discount;
																	const final_discounted_amount = refined_price - discounted_amount;
																	_.final.second_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
																	_.state.discounted.second_product = final_discounted_amount;
																	const total_final_discount =  _.state.discounted.first_product + _.state.discounted.second_product;
																	_.final.selling_plan.finalorderregular.classList.remove('underline');
																	_.final.second_product.regular_price.classList.remove('underline');
																	_.final.second_product.discount_price.classList.add('underline');                                    
															}                         
													}
											})
									}
									const variantId = event.target.closest('label').querySelector('input[type="radio"]').value;
									_.state.second_product = variantId;

									if (_.state.filteredVariantSellingPlan.length > 0) {
										// Try to find the 6-week selling plan
										const sixWeekPlan = _.state.filteredVariantSellingPlan.find(plan =>
											plan.sellingPlanName &&
											plan.sellingPlanName.toLowerCase().includes('6') &&
											plan.sellingPlanName.toLowerCase().includes('week')
										);

										if (sixWeekPlan) {
											_.state.selling_plan = sixWeekPlan.sellingPlanId;
										} else {
											// Fall back to first plan if 6-week not found
											_.state.selling_plan = _.state.filteredVariantSellingPlan[0].sellingPlanId;
										}
									} else {
										_.state.selling_plan = null;
									}
							})
							if(el.closest('label').classList.contains('active')) {
									_.final.second_product.image.src = el.querySelector('input[type="radio"]').dataset.variantImage;
									_.final.second_product.image.dataset.src = el.querySelector('input[type="radio"]').dataset.variantImage;
									_.final.second_product.title.textContent = el.querySelector('input[type="radio"]').dataset.variantTitle;
									_.final.second_product.regular_price.textContent = el.querySelector('input[type="radio"]').dataset.variantPrice;
									_.final.selling_plan.onetimepurchase.textContent = "$99";
									_.state.second_product = el.querySelector('input[type="radio"]').value;
									_.state.filteredVariantSellingPlan = [];
									_.state.filteredVariantSellingPlan = window.second_products_selling_plan.filter(plan => plan.variantId === el.querySelector('input[type="radio"]').value);

									// Calculate discounted price from selling plan for regular_price_origin (initialization)
									const init_current_currency = el.querySelector('input[type="radio"]').dataset.currentCurrency;
									const init_regular_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;
									const init_sixWeekPlan = _.state.filteredVariantSellingPlan.find(plan =>
										plan.sellingPlanName &&
										plan.sellingPlanName.toLowerCase().includes('6') &&
										plan.sellingPlanName.toLowerCase().includes('week')
									);

									if (init_sixWeekPlan && init_sixWeekPlan.sellingPlanPriceValue) {
										const init_discount_percentage = parseInt(init_sixWeekPlan.sellingPlanPriceValue) * 0.01;
										const init_discounted_price = init_regular_price - (init_regular_price * init_discount_percentage);
										_.final.second_product.regular_price_origin.textContent = `${init_current_currency}${init_discounted_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
									} else {
										_.final.second_product.regular_price_origin.textContent = el.querySelector('input[type="radio"]').dataset.variantPrice;
									}
									if(_.state.filteredVariantSellingPlan.length > 0) {
											if(_.selector.variant_selling_plan_selected) {
													_.selector.variant_selling_plan_selected.innerHTML = "";
													_.state.filteredVariantSellingPlan.forEach((option, index) => {
															var selling_plan_option = document.createElement("option");
															selling_plan_option.value = option.sellingPlanId;
															selling_plan_option.text = option.sellingPlanName;
															selling_plan_option.dataset.sellingPlanPriceType = option.sellingPlanPriceType;
															selling_plan_option.dataset.sellingPlanPriceValue = option.sellingPlanPriceValue;
															selling_plan_option.dataset.variantId = option.variantId;
															selling_plan_option.dataset.variantPrice = option.variantPrice;
															selling_plan_option.dataset.currentCurrency = option.currentCurrency;
															selling_plan_option.dataset.sellingPlanId = option.sellingPlanId;
															index == 0 && (selling_plan_option.selected = true);
															_.selector.variant_selling_plan_selected.append(selling_plan_option);
													})                                
											}                            
									}
									const regular_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;
									const current_currency = el.querySelector('input[type="radio"]').dataset.currentCurrency;
									_.state.regular.second_product = regular_price;
									// Update prices: discount shows total, regular shows just diffuser (second product is free)
						const finalOrderTotal = parseInt(_.state.regular.first_product) + parseInt(_.state.regular.second_product);
						if (_.final.selling_plan.finalorderdiscount && _.state.regular.second_product > 0) {
							_.final.selling_plan.finalorderdiscount.textContent = `${current_currency}${finalOrderTotal.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
						}
						// Use discounted diffuser price if available, otherwise regular price
						const final_regular_price = _.discount.diffuser_discount_percent > 0 ? parseInt(_.state.discounted_first_product) : parseInt(_.state.regular.first_product);
									_.final.selling_plan.finalorderregular.textContent = `${current_currency}${final_regular_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
									// _.final.selling_plan.finalplanname.textContent =`${_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].text}`;
									_.selector.subscription_input.forEach(detail => {
											if(detail.checked) {
													if(detail.value !== 'one-time-purchase') {                               
															const selling_plan_discount = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanPriceValue) * 0.01;
															const refined_price = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.variantPrice) / 100;                               
															const discounted_amount = refined_price * selling_plan_discount;
															const final_discounted_amount = refined_price - discounted_amount;
															_.final.second_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
															_.final.selling_plan.subscription.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
															_.state.discounted.second_product = final_discounted_amount;
															const total_final_discount =  _.state.discounted.first_product + _.state.discounted.second_product; 
															_.final.selling_plan.finalorderregular.classList.add('underline');
															_.final.second_product.regular_price.classList.add('underline');
															// _.final.second_product.discount_price.classList.remove('underline');
															detail.value = _.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanId;
															_.state.selling_plan = _.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanId;
													} else {
															const one_time_purchase_discount = parseInt(detail.dataset.oneTimePurchaseDiscount) * 0.01;
															const refined_price = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.variantPrice) / 100;                                
															const discounted_amount = refined_price * one_time_purchase_discount;
															const final_discounted_amount = refined_price - discounted_amount;
															_.final.second_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
															_.state.discounted.second_product = final_discounted_amount;
															const total_final_discount =  _.state.discounted.first_product + _.state.discounted.second_product;
															_.final.selling_plan.finalorderregular.classList.remove('underline');
															_.final.second_product.regular_price.classList.remove('underline');
															_.final.second_product.discount_price.classList.add('underline');
													}     
											}
									})
									const variantId = el.querySelector('input[type="radio"]').value;
									_.state.second_product = variantId;

									_.state.filteredVariantSellingPlan = window.second_products_selling_plan.filter(plan => plan.variantId === variantId);
									if (_.state.filteredVariantSellingPlan.length > 0) {
										// Try to find the 6-week selling plan
										const sixWeekPlan = _.state.filteredVariantSellingPlan.find(plan =>
											plan.sellingPlanName &&
											plan.sellingPlanName.toLowerCase().includes('6') &&
											plan.sellingPlanName.toLowerCase().includes('week')
										);

										if (sixWeekPlan) {
											_.state.selling_plan = sixWeekPlan.sellingPlanId;
										} else {
											// Fall back to first plan if 6-week not found
											_.state.selling_plan = _.state.filteredVariantSellingPlan[0].sellingPlanId;
										}
									} else {
										_.state.selling_plan = null;
									}
							}
					})
			}
			if(_.selector.next_steps.length > 0) {
					_.selector.next_steps.forEach(el => {
							el.addEventListener('click', event => {
									const nextStep = parseInt(event.target.closest("button").dataset.nextStep);

									// CHECK FOR STEP 3 FIRST
									if (nextStep == 3) {
											// Apply discount code first
											_.applyDiscountCode();

											// Check if original mode is enabled (show step 3 without CRO)
											if (_.discount.step_3_mode === 'original') {
													// Don't return early - let the normal step 3 DOM update happen below
											}
											// Check if inline mode is enabled
											else if (_.discount.step_3_mode === 'inline') {
													_.showCroInlineContent();
													return; // Exit early - don't modify DOM
											}
											// Fallback: redirect behavior
											else {
													// Build data payload for CRO page
													const byskData = {
															first_product: _.state.first_product,
															second_product: _.state.second_product,
															selling_plan: _.state.selling_plan,
															first_product_title: _.final.first_product.title ? _.final.first_product.title.textContent : '',
															first_product_image: _.final.first_product.image ? _.final.first_product.image.src : '',
															first_product_price: _.state.regular.first_product,
															first_product_discounted_price: _.state.discounted_first_product,
															diffuser_discount_percent: _.discount.diffuser_discount_percent,
															second_product_title: _.final.second_product.title ? _.final.second_product.title.textContent : '',
															second_product_image: _.final.second_product.image ? _.final.second_product.image.src : '',
															second_product_price: _.state.regular.second_product,
															filteredVariantSellingPlan: _.state.filteredVariantSellingPlan,
															discount_code: _.discount.subscription,
															delivery_frequency: _.discount.delivery_frequency
													};


													// Store in sessionStorage
													sessionStorage.setItem('bysk_selection', JSON.stringify(byskData));

													// Redirect to CRO page
													window.location.href = _.discount.redirect_page;
													return; // Exit early - don't modify DOM
											}
									}

									// Only update DOM for steps 1 and 2
									_.selector.steps.forEach(step => {
											if(parseInt(step.dataset.thisStep) == nextStep) {
													step.classList.add('active');
											} else {
													step.classList.remove('active');
											}
									});

									// Progress bar animation for step 2
									if (nextStep == 2) {
											let progress = 33.33;
											const interval = setInterval(() => {
													progress += 1;
													_.selector.step2_progressbar.value = progress;
													if(progress >= 66) {
															clearInterval(interval);
													}
											}, 30);
									}
							})
					})
			}
			if(_.selector.prev_steps.length > 0) {
					_.selector.prev_steps.forEach(el => {
							el.addEventListener('click', event => {
									_.selector.steps.forEach(step => {
											if(parseInt(step.dataset.thisStep) == parseInt(event.target.closest("button").dataset.prevStep)) {
													step.classList.add('active');
											} else {
													step.classList.remove('active');
											}     
											if( parseInt(event.target.closest("button").dataset.prevStep) == 2) {
													let progress = 100;
													const interval = setInterval(() => {
															progress-= 1;
															_.selector.step2_progressbar.value = progress;
															if(progress <= 66) {
																	clearInterval(interval);
															}
													}, 30);
											}                    
											if( parseInt(event.target.closest("button").dataset.prevStep) == 1) {
													let progress = 66.66;
													const interval = setInterval(() => {
															progress-= 1;
															_.selector.step1_progressbar.value = progress;
															if(progress <= 33) {
																	clearInterval(interval);
															}
													}, 30);
											}                                      
									})
							})
					})
			}
			if(_.selector.show_info.length > 0) {
					_.selector.show_info.forEach(el => {
							el.addEventListener('click', event => {
									const iconTarget = event.target.nodeName == "path" ? event.target.closest('svg') : event.target;
									const show_info = iconTarget.closest('.products-picker').querySelector(`.product-description[data-rank-number="${iconTarget.dataset.rankNumber}"]`);
									show_info && show_info.classList.toggle('active');      
							})
					})
			}
			if(_.selector.subscription_label.length > 0) {
					_.selector.subscription_label.forEach(el => {
							el.addEventListener('click', event => {
									_.selector.subscription_label.forEach(label => {
											label.classList.remove('active');
									})
									event.target.closest('label').classList.add('active');
									if(event.target.closest('label').classList.contains('active')) {
											// Only set from radio button for full templates, not subscription-only
											if (_.discount.delivery_frequency !== 'subscription') {
													_.state.selling_plan = event.target.closest('label').querySelector('input[type="radio"]').value;
											}
									}
							})
							if(el.closest('label').classList.contains('active')) {
									// Only set from radio button for full templates, not subscription-only
									// For subscription-only, rely on auto-selected selling plan from step 2
									if (_.discount.delivery_frequency !== 'subscription') {
											_.state.selling_plan = el.querySelector('input[type="radio"]').value;
									} else {
									}
							}
					})
			}
			if(_.selector.subscription_input.length > 0) {
					_.selector.subscription_input.forEach(el => {
							el.addEventListener('change', event => {
									if(event.target.value === 'one-time-purchase') {
											_.final.first_product.discount_price.classList.add('underline');
											_.final.first_product.regular_price.classList.remove('underline');
											_.final.second_product.discount_price.classList.add('underline');
											_.final.second_product.regular_price.classList.remove('underline');
											_.final.selling_plan.finalorderregular.classList.remove('underline');
											_.selector.variant_selling_plan_selected.disabled = true;
									} else {
											_.final.first_product.discount_price.classList.remove('underline');
											_.final.first_product.regular_price.classList.add('underline');
											// _.final.second_product.discount_price.classList.remove('underline');
											_.final.second_product.regular_price.classList.add('underline');
											_.final.selling_plan.finalorderregular.classList.add('underline');
											_.selector.variant_selling_plan_selected.disabled = false;
									}

									// Re-apply discount code when purchase type changes (only on full template)
									if (_.discount.delivery_frequency === 'full') {
											_.applyDiscountCode();
									}
							})
					})
			}
			if(_.selector.arrow_steps.length > 0) {
					_.selector.arrow_steps.forEach(el => {
							el.addEventListener('click', event => {
									const nextStep = parseInt(event.target.closest(".arrow").dataset.nextStep);

									// CHECK FOR STEP 3 FIRST
									if (nextStep == 3) {
											// Apply discount code first
											_.applyDiscountCode();

											// Check if original mode is enabled (show step 3 without CRO)
											if (_.discount.step_3_mode === 'original') {
													// Don't return early - let the normal step 3 DOM update happen below
											}
											// Check if inline mode is enabled
											else if (_.discount.step_3_mode === 'inline') {
													_.showCroInlineContent();
													return; // Exit early - don't modify DOM
											}
											// Fallback: redirect behavior
											else {
													// Build data payload for CRO page
													const byskData = {
															first_product: _.state.first_product,
															second_product: _.state.second_product,
															selling_plan: _.state.selling_plan,
															first_product_title: _.final.first_product.title ? _.final.first_product.title.textContent : '',
															first_product_image: _.final.first_product.image ? _.final.first_product.image.src : '',
															first_product_price: _.state.regular.first_product,
															first_product_discounted_price: _.state.discounted_first_product,
															diffuser_discount_percent: _.discount.diffuser_discount_percent,
															second_product_title: _.final.second_product.title ? _.final.second_product.title.textContent : '',
															second_product_image: _.final.second_product.image ? _.final.second_product.image.src : '',
															second_product_price: _.state.regular.second_product,
															filteredVariantSellingPlan: _.state.filteredVariantSellingPlan,
															discount_code: _.discount.subscription,
															delivery_frequency: _.discount.delivery_frequency
													};


													// Store in sessionStorage
													sessionStorage.setItem('bysk_selection', JSON.stringify(byskData));

													// Redirect to CRO page
													window.location.href = _.discount.redirect_page;
													return; // Exit early - don't modify DOM
											}
									}

									// Only update DOM for steps 1 and 2
									_.selector.steps.forEach(step => {
											if(parseInt(step.dataset.thisStep) == nextStep) {
													step.classList.add('active');
											} else {
													step.classList.remove('active');
											}
									});

									// Progress bar animation for step 2
									if (nextStep == 2) {
											let progress = 33.33;
											const interval = setInterval(() => {
													progress += 1;
													_.selector.step2_progressbar.value = progress;
													if(progress >= 66) {
															clearInterval(interval);
													}
											}, 30);
									}
							})
					})
			}
			if(_.selector.final_order_purchase) {
					_.selector.final_order_purchase.addEventListener('click', () => {
						 _.checkout();
					})
			}
			if(_.selector.variant_selling_plan_selected) {
					_.selector.variant_selling_plan_selected.addEventListener("change", event => {
							_.final.selling_plan.finalplanname.textContent = event.target.options[event.target.selectedIndex].text;
							const one_time_purchase_discount = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanPriceValue) * 0.01;
							const refined_price = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.variantPrice) / 100;                                
							const discounted_amount = refined_price * one_time_purchase_discount;
							const final_discounted_amount = refined_price - discounted_amount;
							_.final.second_product.discount_price.textContent = `${event.target.options[event.target.selectedIndex].dataset.currentCurrency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
							_.final.selling_plan.subscription.textContent = `${event.target.options[event.target.selectedIndex].dataset.currentCurrency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
							_.state.selling_plan = _.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanId;
					})
			}
			console.log("sdfdsdf", _.selector.plan_selector.length);
			if(_.selector.plan_selector.length > 0) {
				_.selector.plan_selector.forEach(el => {
					// дефолт с учетом checked в HTML (у вас checked на recurring)
					if(el.checked) {
					_.state.plan = el.value; // 'recurring' | 'one-time'
					if(_.selector.variant_selling_plan_selected) {
						_.selector.variant_selling_plan_selected.disabled = (el.value !== 'recurring');
					}
					}
					el.addEventListener('change', (event) => {
					_.state.plan = event.target.value;
					if(_.state.plan == 'No Subscription') {
						_.selector.plan_price.classList.remove('recurring');
					}
					else {
						_.selector.plan_price.classList.add('recurring');
					}
					if(_.selector.variant_selling_plan_selected) {
						_.selector.variant_selling_plan_selected.disabled = (event.target.value !== 'recurring');
					}
					});
				});
			}

	}
	BuildYourStarterKit.prototype.applyDiscountCode = function() {
		var _ = this;
		let discountCode;

		// Determine which discount code to apply
		if (_.discount.delivery_frequency === 'subscription') {
			// Subscription-only template - always apply subscription discount
			discountCode = _.discount.subscription;
		} else if (_.discount.delivery_frequency === 'full') {
			// Full template - check which option is selected
			let isSubscriptionSelected = false;
			_.selector.subscription_input.forEach(input => {
				if (input.checked && input.value !== 'one-time-purchase') {
					isSubscriptionSelected = true;
				}
			});

			if (isSubscriptionSelected) {
				discountCode = _.discount.subscription;
			} else {
				discountCode = _.discount.onetime;
			}
		} else {
			// Fallback - no discount configuration
			return;
		}

		// Apply the discount code
		if (discountCode && discountCode !== '') {
			fetch('https://scentifyhome.com/discount/' + discountCode).then(function(response) {
				return response;
			}).then(function(response){
			}).catch(function(error) {
			});
		}
	}
	BuildYourStarterKit.prototype.showCroInlineContent = function() {
		var _ = this;

		// Get the CRO inline container
		const croContainer = document.getElementById('bysk-cro-inline-container');
		if (!croContainer) {
			// Fallback to redirect if container not found
			const byskData = {
				first_product: _.state.first_product,
				second_product: _.state.second_product,
				selling_plan: _.state.selling_plan,
				first_product_title: _.final.first_product.title ? _.final.first_product.title.textContent : '',
				first_product_image: _.final.first_product.image ? _.final.first_product.image.src : '',
				first_product_price: _.state.regular.first_product,
				first_product_discounted_price: _.state.discounted_first_product,
				diffuser_discount_percent: _.discount.diffuser_discount_percent,
				second_product_title: _.final.second_product.title ? _.final.second_product.title.textContent : '',
				second_product_image: _.final.second_product.image ? _.final.second_product.image.src : '',
				second_product_price: _.state.regular.second_product,
				filteredVariantSellingPlan: _.state.filteredVariantSellingPlan,
				discount_code: _.discount.subscription,
				delivery_frequency: _.discount.delivery_frequency
			};
			sessionStorage.setItem('bysk_selection', JSON.stringify(byskData));
			window.location.href = _.discount.redirect_page;
			return;
		}

		// Hide all existing steps
		_.selector.steps.forEach(step => {
			step.classList.remove('active');
		});

		// Show CRO inline container
		croContainer.style.display = 'block';

		// Update any Swiper instances that were initialized while hidden
		setTimeout(function() {
			const swiperComponents = croContainer.querySelectorAll('swiper-component');

			swiperComponents.forEach(function(component, index) {

				// Try to upgrade the custom element if not yet upgraded
				if (typeof component.initSwiper !== 'function') {
					customElements.upgrade(component);
				}

				const container = component.querySelector('[data-swiper]');

				if (container && container.swiper) {
					// Destroy existing swiper that was initialized while hidden
					container.swiper.destroy(true, true);
				}

				// Reinitialize via swiper-component

				if (typeof component.initSwiper === 'function') {
					component.initSwiper();
				} else if (container && typeof window.Swiper !== 'undefined') {
					// Fallback: Initialize Swiper directly if global Swiper is available
					const options = container.dataset.swiperOptions ? JSON.parse(container.dataset.swiperOptions) : {};
					new window.Swiper(container, options);
				} else {
				}
			});
		}, 100);

		// Scroll to top of page
		window.scrollTo({ top: 0, behavior: 'smooth' });

		// Initialize the inline floating checkout with current state
		_.initializeInlineCheckout();

		// Setup back button handler
		const backButton = document.getElementById('bysk-cro-back-button');
		if (backButton && !backButton.hasAttribute('data-listener-added')) {
			backButton.setAttribute('data-listener-added', 'true');
			backButton.addEventListener('click', function() {
				_.returnToStep2FromCRO();
			});
		}

		// Wire up all CRO checkout buttons
		const checkoutButtons = croContainer.querySelectorAll('.bysk-cro-checkout-btn, a[href="#"]');
		checkoutButtons.forEach(function(btn) {
			const text = (btn.textContent || '').toLowerCase();
			if (text.includes('checkout') || text.includes('check now')) {
				if (!btn.hasAttribute('data-listener-added')) {
					btn.setAttribute('data-listener-added', 'true');
					btn.addEventListener('click', function(e) {
						e.preventDefault();
						_.checkout();
					});
				}
			}
		});

	}

	BuildYourStarterKit.prototype.initializeInlineCheckout = function() {
		var _ = this;

		// Get inline checkout elements
		const firstImage = document.getElementById('bysk-inline-first-image');
		const firstTitle = document.getElementById('bysk-inline-first-title');
		const firstPrice = document.getElementById('bysk-inline-first-price');
		const secondImage = document.getElementById('bysk-inline-second-image');
		const secondTitle = document.getElementById('bysk-inline-second-title');
		const renewalPrice = document.getElementById('bysk-inline-renewal-price');
		const totalCrossed = document.getElementById('bysk-inline-total-crossed');
		const totalPrice = document.getElementById('bysk-inline-total-price');
		const togglePrice = document.getElementById('bysk-inline-toggle-price');
		const checkoutPanel = document.getElementById('bysk-inline-floating-checkout');

		// Populate first product info
		if (firstImage && _.final.first_product.image) {
			firstImage.src = _.final.first_product.image.src || '';
			firstImage.alt = _.final.first_product.title ? _.final.first_product.title.textContent : 'Diffuser';
		}
		if (firstTitle && _.final.first_product.title) {
			firstTitle.textContent = _.final.first_product.title.textContent || 'Diffuser';
		}
		if (firstPrice) {
			// Check if diffuser discount applies
			if (_.discount.diffuser_discount_percent > 0) {
				// Create or update original price span
				let originalPriceSpan = document.getElementById('bysk-inline-first-original-price');
				if (!originalPriceSpan) {
					originalPriceSpan = document.createElement('span');
					originalPriceSpan.id = 'bysk-inline-first-original-price';
					originalPriceSpan.className = 'diffuser-original-price';
					firstPrice.parentNode.insertBefore(originalPriceSpan, firstPrice);
				}
				originalPriceSpan.textContent = '$' + Math.round(_.state.regular.first_product);
				originalPriceSpan.style.display = 'inline';
				firstPrice.textContent = '$' + Math.round(_.state.discounted_first_product);
				firstPrice.className = 'product-price diffuser-discounted-price';
				// Show discount badge
				let discountBadge = document.getElementById('bysk-inline-discount-badge');
				if (discountBadge) {
					discountBadge.textContent = Math.round(_.discount.diffuser_discount_percent) + '% OFF';
					discountBadge.style.display = 'inline';
				}
			} else {
				firstPrice.textContent = '$' + Math.round(_.state.regular.first_product);
				// Hide discount badge if no discount
				let discountBadge = document.getElementById('bysk-inline-discount-badge');
				if (discountBadge) {
					discountBadge.style.display = 'none';
				}
			}
		}

		// Populate second product info
		if (secondImage && _.final.second_product.image) {
			secondImage.src = _.final.second_product.image.src || '';
			secondImage.alt = _.final.second_product.title ? _.final.second_product.title.textContent : 'Fragrance';
		}
		if (secondTitle && _.final.second_product.title) {
			secondTitle.textContent = _.final.second_product.title.textContent || 'Fragrance';
		}

		// Populate renewal price (use discounted subscription price)
		if (renewalPrice) {
			// Find the 6-week selling plan to get the discount
			const sixWeekPlan = _.state.filteredVariantSellingPlan.find(plan =>
				plan.sellingPlanName &&
				plan.sellingPlanName.toLowerCase().includes('6') &&
				plan.sellingPlanName.toLowerCase().includes('week')
			);

			if (sixWeekPlan && sixWeekPlan.sellingPlanPriceValue) {
				const discount_percentage = parseInt(sixWeekPlan.sellingPlanPriceValue) * 0.01;
				const discounted_renewal = _.state.regular.second_product - (_.state.regular.second_product * discount_percentage);
				renewalPrice.textContent = '$' + Math.round(discounted_renewal);
			} else {
				renewalPrice.textContent = '$' + Math.round(_.state.regular.second_product);
			}
		}

		// Calculate totals
		const totalCrossedValue = _.state.regular.first_product + _.state.regular.second_product;
		// Use discounted diffuser price if available
		const actualDiffuserPrice = _.discount.diffuser_discount_percent > 0 ? _.state.discounted_first_product : _.state.regular.first_product;
		const totalPriceValue = actualDiffuserPrice; // Second product is free

		if (totalCrossed) {
			totalCrossed.textContent = '$' + Math.round(totalCrossedValue);
		}
		if (totalPrice) {
			totalPrice.textContent = '$' + Math.round(totalPriceValue);
		}
		if (togglePrice) {
			togglePrice.textContent = '$' + Math.round(totalPriceValue);
		}

		// Show the checkout panel
		if (checkoutPanel) {
			checkoutPanel.style.display = 'block';
			// Move to body to escape any transform contexts
			document.body.appendChild(checkoutPanel);
		}

		// Mobile toggle behavior
		const isMobile = window.innerWidth < 768;
		const toggleBar = document.getElementById('bysk-inline-checkout-toggle');

		if (isMobile && toggleBar && checkoutPanel) {
			// Start collapsed on mobile
			checkoutPanel.classList.add('collapsed');

			// Toggle click handler
			if (!toggleBar.hasAttribute('data-listener-added')) {
				toggleBar.setAttribute('data-listener-added', 'true');
				toggleBar.addEventListener('click', function() {
					checkoutPanel.classList.toggle('collapsed');
				});
			}

			// Auto-open at 75% scroll
			let hasAutoOpened = false;
			window.addEventListener('scroll', function() {
				if (hasAutoOpened) return;
				const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
				const scrollPercent = window.scrollY / scrollableHeight;
				if (scrollPercent >= 0.75 && checkoutPanel.classList.contains('collapsed')) {
					checkoutPanel.classList.remove('collapsed');
					hasAutoOpened = true;
				}
			});
		}

		// Wire up the inline checkout button
		const checkoutBtn = document.getElementById('bysk-inline-checkout-btn');
		if (checkoutBtn && !checkoutBtn.hasAttribute('data-listener-added')) {
			checkoutBtn.setAttribute('data-listener-added', 'true');
			checkoutBtn.addEventListener('click', function() {
				_.checkout();
			});
		}

	}

	BuildYourStarterKit.prototype.returnToStep2FromCRO = function() {
		var _ = this;

		// Hide CRO inline container
		const croContainer = document.getElementById('bysk-cro-inline-container');
		if (croContainer) {
			croContainer.style.display = 'none';
		}

		// Hide inline floating checkout
		const checkoutPanel = document.getElementById('bysk-inline-floating-checkout');
		if (checkoutPanel) {
			checkoutPanel.style.display = 'none';
		}

		// Show Step 2
		_.selector.steps.forEach(step => {
			if (parseInt(step.dataset.thisStep) == 2) {
				step.classList.add('active');
			} else {
				step.classList.remove('active');
			}
		});

		// Scroll to top
		window.scrollTo({ top: 0, behavior: 'smooth' });

	}

	BuildYourStarterKit.prototype.checkout = async function() {
		var _ = this;

		// Handle checkout button state (may not exist in inline CRO mode)
		if (_.selector.final_order_purchase) {
			_.selector.final_order_purchase.classList.add("active");
		}

		// Handle inline checkout button state
		const inlineCheckoutBtn = document.getElementById('bysk-inline-checkout-btn');
		if (inlineCheckoutBtn) {
			const buttonText = inlineCheckoutBtn.querySelector('.button-text');
			if (buttonText) buttonText.textContent = 'Processing...';
			inlineCheckoutBtn.disabled = true;
		}

		// Add loading state to CRO checkout buttons
		document.querySelectorAll('.bysk-cro-checkout-btn').forEach(function(btn) {
			btn.style.opacity = '0.6';
			btn.style.pointerEvents = 'none';
			btn.textContent = 'Processing...';
		});

		let formData;

		// Build the items array
		let items = [
			{
				id: parseInt(_.state.first_product),
				quantity: 1,
				properties: {
					'_starter-kit': 'true',
					...(_.discount.diffuser_extra_property ? { [_.discount.diffuser_extra_property]: 'true' } : {})
				}
			}
		];

		// Add second product with proper selling plan if available
		let secondItem = {
			id: parseInt(_.state.second_product),
			quantity: 1
		};

		// Validate and set selling plan
		let sellingPlanToUse = _.state.selling_plan;

		// For subscription-only templates, ensure we always have a valid selling plan
		if (_.discount.delivery_frequency === 'subscription') {
			// Check if current selling_plan is valid (must be a number or convertible to number)
			const isValidPlan = sellingPlanToUse &&
				sellingPlanToUse !== 'one-time-purchase' &&
				sellingPlanToUse !== 'subscription' &&
				!isNaN(parseInt(sellingPlanToUse));

			if (!isValidPlan) {

				// Fallback: Use first available selling plan from filtered list
				if (_.state.filteredVariantSellingPlan && _.state.filteredVariantSellingPlan.length > 0) {
					// Try to find 6-week plan first
					const sixWeekPlan = _.state.filteredVariantSellingPlan.find(plan =>
						plan.sellingPlanName &&
						plan.sellingPlanName.toLowerCase().includes('6') &&
						plan.sellingPlanName.toLowerCase().includes('week')
					);

					if (sixWeekPlan) {
						sellingPlanToUse = sixWeekPlan.sellingPlanId;
					} else {
						sellingPlanToUse = _.state.filteredVariantSellingPlan[0].sellingPlanId;
					}
				} else {
				}
			}
		}

		// Only add selling_plan if we have one selected
		if (sellingPlanToUse && sellingPlanToUse !== 'one-time-purchase') {
			secondItem.selling_plan = parseInt(sellingPlanToUse);
		} else {
		}

		items.push(secondItem);

		formData = {
			items: items
		};
		await fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(formData)
		})
		.then(r => r.json())
		.catch(error => {
			// Restore inline checkout button state
			const inlineCheckoutBtn = document.getElementById('bysk-inline-checkout-btn');
			if (inlineCheckoutBtn) {
				const buttonText = inlineCheckoutBtn.querySelector('.button-text');
				if (buttonText) buttonText.textContent = 'CHECKOUT';
				inlineCheckoutBtn.disabled = false;
			}
			// Restore CRO checkout buttons
			document.querySelectorAll('.bysk-cro-checkout-btn').forEach(function(btn) {
				btn.style.opacity = '1';
				btn.style.pointerEvents = 'auto';
				btn.textContent = 'Checkout Now';
			});
		})
		.finally(() => {
			// Hide Rebuy cart to prevent it from opening during redirect
			const rebuyCart = document.querySelector('.rebuy-cart');
			if (rebuyCart) {
				rebuyCart.style.display = 'none';
			}

			window.location.href = '/checkout';

			// Reset button states
			if (_.selector.final_order_purchase) {
				_.selector.final_order_purchase.classList.remove("active");
			}
		});
	}
	BuildYourStarterKit = new BuildYourStarterKit;
}
BuildYourStarterKit()
})();